import { ComponentType as A } from "../../registries/types/propTypes.js";
import G from "../video-section-transformer/video-section-transformer.js";
const C = (r) => {
  var s, c, t, g, e, p, i, m, u, b;
  const o = Array.isArray(r == null ? void 0 : r.video_banner) ? r == null ? void 0 : r.video_banner[0] : r == null ? void 0 : r.video_banner, _ = (c = (s = o == null ? void 0 : o.background_image) == null ? void 0 : s.images) == null ? void 0 : c.map((l) => ({
    url: l.image.url,
    altText: l.alt_text,
    viewport: l.viewport
  })), n = {
    videoSection: G(o)
  }, x = (g = (t = o == null ? void 0 : o.logo) == null ? void 0 : t.images) == null ? void 0 : g.map((l) => ({
    url: l.image.url,
    altText: l.alt_text,
    viewport: l.viewport
  })), w = o == null ? void 0 : o.overlay_gradient, h = (e = o == null ? void 0 : o.linear_gradient) == null ? void 0 : e.color, y = {
    text: (p = o == null ? void 0 : o.shop) == null ? void 0 : p.text,
    url: (i = o == null ? void 0 : o.shop) == null ? void 0 : i.url,
    target: (m = o == null ? void 0 : o.shop) == null ? void 0 : m.target
  }, T = (o == null ? void 0 : o.description) ?? "", f = ((u = o == null ? void 0 : o.watch) == null ? void 0 : u.label) ?? "", V = ((b = o == null ? void 0 : o.background_video) == null ? void 0 : b.url) ?? "";
  return {
    componentType: A.video_banner,
    images: _,
    brandLogo: x,
    overlayGradient: w,
    linearGradient: h,
    shopNow: y,
    brandTagLine: T,
    videoModalData: n,
    watchVideoText: f,
    backgroundVideoUrl: V
  };
};
export {
  C as default
};
//# sourceMappingURL=video-banner-transformer.js.map
